import { TypeCurveParameterBase } from './base/type-curve-parameter-base';

export class TypeCurveParameter extends TypeCurveParameterBase { }